import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";

import "./App.css";
import routes from "./routes/routes";
import AppErrorBoundary from "./components/common/AppErrorBoundary";
import { useSocketSetup } from "./hooks/useSocketSetup";

function App() {
  // Gère la connexion socket, l'enregistrement sécurisé et les notifications temps réel
  useSocketSetup();

  return (
    <AppErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={routes} />
      </Suspense>
    </AppErrorBoundary>
  );
}

export default App;
